module.exports = __webpack_public_path__ + "img/venuetwo-jfdhtitle.86e52c5b.png";